import { SET_CANCEL_MEMBER_SHIP } from '../actions/type';

const initState = {
    data: {},
    status: null
}

const cancelMemberShip = (state = initState, action) => {
    switch (action.type) {
        case SET_CANCEL_MEMBER_SHIP:
            const payload = action.payload;
            return { ...state, ...payload };
        default:
            return state;
    }
}

export default cancelMemberShip
